// import assets
import './assets/sass/bootstrap.scss';
import './assets/css/geosuggest.css';
import './assets/css/react-datetime.css';
import './assets/css/utility.css';
import './assets/css/spinkit.css';

// import JS
import React from 'react';
import ReactDOM from 'react-dom';
import Raven from 'raven-js';
import store from 'store';

import {Provider} from 'react-redux';
import {fetchUser} from './store/actions/user';
import rStore from './store'
import routes from './routes';


/*global request google */
/*eslint no-undef: "error"*/

console.log('ENV: ', process.env.REACT_APP_POLYRENTS_API_BASE_URL);
console.log('INTERCOM: ', process.env.REACT_APP_POLYRENTS_INTERCOM_APP_ID);
//Boot Intercom
window.Intercom('boot', {
    app_id: process.env.REACT_APP_POLYRENTS_INTERCOM_APP_ID
});

//Initialize Sentry
Raven.config(process.env.REACT_APP_POLYRENTS_SENTRY_DSN).install();


if (store.get('access_token')) {
    rStore.dispatch(fetchUser());
}

// Router
ReactDOM.render(
    <Provider store={rStore}>
        {routes}
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js